export default {
    methods: {
        responseToken(response) {
            let responseTokens = this.$store.getters['v4/track/responseTokens']
            return responseTokens[response.name]
        }
    }
}
